<template>
	<view class="my-wrap">
		<view class="qiehuanzhangaoBtn" @click="qiehuanzhangaoBtn">
			<text>切换账号</text>
		</view>
		<view class="my-img" v-if="myInformation.headImg">
			<image :src="myInformation.headImg" mode="aspectFill"></image>
		</view>
		<view class="content">
			<view class="dianName">{{myInformation.name}}</view>
			<view class="adressLine">
				<text class="informationTitle1">地址：</text>
				<text class="informationTitle2">{{myInformation.registeredAddress ? myInformation.registeredAddress : ''}}</text>
			</view>
			<view class="adressLine">
				<text class="informationTitle1">法人：</text>
				<text class="informationTitle2">{{myInformation.linker}}</text>
			</view>
			<view class="adressLine">
				<text class="informationTitle1">手机：</text>
				<text class="informationTitle2">{{myInformation.phone}}</text>
			</view>
			<view class="guanliyijian-box">
				<view class="guanliyijian-block" @click="gotoSignerManagement">
					<image src="../../static/image/qianshouIcon.png" mode="aspectFill"></image>
					<text>签收人管理</text>
				</view>
				<view class="guanliyijian-block" @click="gotoOpinionList">
					<image src="../../static/image/yijianIcon.png" mode="aspectFill"></image>
					<text>意见与建议</text>
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				myInformation:{}
			}
		},
		onShow() {
			this.myInformation = this.$store.state.userInfo
		},
		// onPullDownRefresh() {  //下拉属性
			
		// },
		methods: {
			gotoSignerManagement() {
				uni.navigateTo({
					url: '/pagesB/signerManagement/signerManagement'
				})
			},
			gotoOpinionList() {
				uni.navigateTo({
					url: '/pagesC/opinionList/opinionList'
				})
			},
			qiehuanzhangaoBtn() {  //切换账号
			// let openId = this.$store.state.setOpenId
			let _this = this
			uni.login({
				provider: 'weixin',
				success: function (loginRes) {
					console.log(loginRes,'loginRes =====loginRes')
					_this.$u.api.wxlogin({code:loginRes.code}).then(res => {
						let openId = res.result.openId
						if(openId.length != 28) {
							this.$u.toast('openId不正确')
							return
						}
						uni.navigateTo({
							 url:'/pagesA/login/login?openId='+ openId
						})
					})
				}
			})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.my-wrap{
		width: 100%;
		padding: 32rpx;
		box-sizing: border-box;
	}
	.qiehuanzhangaoBtn{
		display: flex;
		flex-direction: row-reverse;
		line-height: 2;
		font-size: 24rpx;
		font-weight: light;
	}
  .my-img{
	  width: 100%;
	  height: 402rpx;
	  image{
		  width: 100%;
		  height: 100%;;
	  }
  }
  .content{
	  margin-top: 40rpx;
	  .dianName{
		  font-size: 32rpx;
		  color: #111111;
		  font-weight: light;
		  line-height: 2.5;
	  }
	  .adressLine{
		  display: flex;
		  text{
			  font-size: 28rpx;
			  color: #111111;
			  font-weight: light;
			  line-height: 2.5;
		  }
		  .informationTitle1{
			  width: 110rpx;
		  }
		  .informationTitle2{
		  	  flex:1;
		  }
	  }
  }
  .guanliyijian-box{
	  display: flex;
	  margin-top: 40rpx;
	  .guanliyijian-block{
		  flex: 1;
		  border:1px solid #1F9F4C;
		  height: 280rpx;
		  border-radius: 8rpx;
		  display: flex;
		  flex-direction: column;
		  align-items: center;
		  justify-content: center;
		  &:first-child{
			  margin-right: 40rpx;
		  }
		  image{
			  width: 80rpx;
			  height: 80rpx;
		  }
		  text{
			  font-size: 28rpx;
			  color: #1F9F4C;
			  font-weight: light;
			  line-height: 3;
		  }
	  }
  }
</style>
